export const INITIALAIZE_REQUEST = 'initialize-request';
export const SLUG_SUCCESS = 'slug-success';
export const PUT_SUCCESS = 'put-success';
export const INITIALAIZE_FAILURE = 'initialaize-failure';